import { h, Component } from "preact";

import Collapsible from "./Collapsible";

class UserPane extends Component {
  render({ userContext = {}, defaultOpen }) {
    const { user, links } = userContext;
    if (!user) {
      return false;
    }

    return (
      <Collapsible title="Current User" defaultOpen={defaultOpen}>
        <div class="user-widget__mega_menu__admin--info">
          <div class="name">{user.display_name}</div>
          <div class="id">{user.id}</div>
          <div class="email">{user.mail}</div>
        </div>
        <ul class="user-widget__mega_menu__admin--links">
          {links.map(link => (
            <li>
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </Collapsible>
    );
  }
}

export default UserPane;



// WEBPACK FOOTER //
// ./src/UserPane.js